import {
  OrganizationSettingsActionTypes,
  FETCH_ORGANIZATION_SETTINGS_REQUEST,
  FETCH_ORGANIZATION_SETTINGS_FAILURE,
  FETCH_ORGANIZATION_SETTINGS_SUCCESS,
  SET_ORGANIZATION_SETTINGS_REQUEST,
  SET_ORGANIZATION_SETTINGS_FAILURE,
  SET_ORGANIZATION_SETTINGS_SUCCESS,
  SET_LOCAL_DISCOUNTS,
  OrganizationSettingsState,
} from "./types";

/**
 * Initial state for the organization settings reducer.
 */
export const initialOrganizationSettingsState: OrganizationSettingsState = {
  // eslint-disable-next-line camelcase
  organizationSettings: {
    id: "",
    skip_guardians: false,
    discounts: [],
    max_user_limit: 0,
  },
  isLoading: false,
  isLoaded: false,
  error: null,
};

/**
 * Reducer function for managing organization settings related state.
 * @param state Current state of the organization settings.
 * @param action Action dispatched to update organization settings state.
 * @returns Updated state of the organization settings.
 */
export function organizationSettingsReducer(
  state = initialOrganizationSettingsState,
  action: OrganizationSettingsActionTypes
): OrganizationSettingsState {
  switch (action.type) {
    case FETCH_ORGANIZATION_SETTINGS_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case FETCH_ORGANIZATION_SETTINGS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };
    case FETCH_ORGANIZATION_SETTINGS_SUCCESS:
      return {
        ...state,
        organizationSettings: action.data,
        isLoaded: true,
        isLoading: false,
      };
    case SET_ORGANIZATION_SETTINGS_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case SET_ORGANIZATION_SETTINGS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };

    case SET_ORGANIZATION_SETTINGS_SUCCESS:
      return {
        ...state,
        organizationSettings: action.data,
        isLoading: false,
        isLoaded: true,
      };

    case SET_LOCAL_DISCOUNTS:
      return {
        ...state,
        organizationSettings: {
          ...state.organizationSettings,
          discounts: action.discounts,
        },
      };

    default:
      return state;
  }
}

export default organizationSettingsReducer;
